import * as pdfjsLib from 'pdfjs-dist/build/pdf.min';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

import consumer from './cable';

$(document).ready(() => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe == 'object') && !(typeof iframeId == 'object')) {
      consumer.disconnect();
      $('#subscription-step-2-success').addClass('d-none');
      $('#subscription-step-2-failure').removeClass('d-none');
    }
  }

  function generateContractIframe(urls) {
    var pdfDocs = [];
    var totalPageCount = 0;
    var pageDetails = [];
    var pageNum = 1; // Current page
    var canvas = document.getElementById('canvasPdf');
    var ctx = canvas.getContext('2d');
    var scale = 1;

    // Load all PDFs and calculate total pages
    async function loadAllPdfs() {
      for (let i = 0; i < urls.length; i++) {
        const pdfDoc = await pdfjsLib.getDocument(urls[i]).promise;
        pdfDocs.push(pdfDoc);

        for (let j = 1; j <= pdfDoc.numPages; j++) {
          pageDetails.push({ documentIndex: i, pageNumber: j });
        }
      }
      totalPageCount = pageDetails.length;
      document.getElementById('page_count').textContent = totalPageCount;

      renderPage(pageNum); // Render the first page
    }

    // Render a specific page
    async function renderPage(num) {
      if (num < 1 || num > totalPageCount) return;

      const { documentIndex, pageNumber } = pageDetails[num - 1];
      const pdfDoc = pdfDocs[documentIndex];
      const page = await pdfDoc.getPage(pageNumber);

      const viewport = page.getViewport({ scale: scale });
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport: viewport,
      }).promise;

      // Update page number display
      document.getElementById('page_num').textContent = pageNum;
    }

    // Navigate to the previous page
    function onPrevPage() {
      if (pageNum > 1) {
        pageNum--;
        renderPage(pageNum);
      }
    }

    // Navigate to the next page
    function onNextPage() {
      if (pageNum < totalPageCount) {
        pageNum++;
        renderPage(pageNum);
      }
    }

    // Attach event listeners to buttons
    document.getElementById('previous').addEventListener('click', onPrevPage);
    document.getElementById('next').addEventListener('click', onNextPage);

    loadAllPdfs(); // Start loading PDFs
    $('#pdf-display').removeClass('d-none');

    $('.edit_subscription').on('ajax:success', function () {
      $('#subscription-step-3').addClass('d-none');
      $('#subscription-step-4').removeClass('d-none');
      $('.breadcrumb-element:nth-child(3)').removeClass('current');
      $('.breadcrumb-element:nth-child(3)').addClass('past');
      $('.breadcrumb-element:nth-child(4)').removeClass('next');
      $('.breadcrumb-element:nth-child(4)').addClass('current');
      $('#completion').text('Étape 4/4');
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  }

  function sendEventToGtm(subscriptionId, subscriptionAmount) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'newSubscription',
      subscriptionid: subscriptionId,
      subscriptionamount: subscriptionAmount,
    });
  }

  setTimeout(docliftDoesNotAnswer, 180000);

  if ($('#signature-subscription-id').length) {
    consumer.subscriptions.create(
      {
        channel: 'SignatureChannel',
        subscription_id: $('#signature-subscription-id').data('id'),
      },
      {
        received(data) {
          try {
            if (data.status == 'success') {
              if (
                typeof data.documents_urls !== 'undefined' &&
                data.documents_urls.length > 0
              ) {
                generateContractIframe(data.documents_urls);
                sendEventToGtm(data.id, data.amount);
              }
              $('#contract-loaded-button').prop('disabled', false);
              $('#contract-loaded-button').removeClass('btn-description');
              $('#contract-loaded-button #contractLoading').addClass('d-none');
              $('#contract-loaded-button #contractReady').removeClass('d-none');
              $('#pending_subscription_title').addClass('d-none');
              $('#contract_generated_title').removeClass('d-none');
              $('#generating_doc_explanations').addClass('d-none');
              $('#generating_doc_ready').removeClass('d-none');
              $('#contract-loading-icon').addClass('d-none');

              $('#contract-loaded-button').on('click', (e) => {
                $('#subscription-step-3').removeClass('d-none');

                $('#subscription-step-2-success').addClass('d-none');

                $('.breadcrumb-element:nth-child(2)').removeClass('current');
                $('.breadcrumb-element:nth-child(2)').addClass('past');
                $('.breadcrumb-element:nth-child(3)').removeClass('next');
                $('.breadcrumb-element:nth-child(3)').addClass('current');
                $('#completion').text('Étape 3/4');
              });
            } else {
              setTimeout(() => {
                $('#subscription-step-2-success').addClass('d-none');
                $('#subscription-step-3').addClass('d-none');
                $('#subscription-step-4').addClass('d-none');
                $('#subscription-step-3-error').removeClass('d-none');
              }, 5000);
            }
          } catch {
            setTimeout(() => {
              $('#subscription-step-2-success').addClass('d-none');
              $('#subscription-step-3').addClass('d-none');
              $('#subscription-step-4').addClass('d-none');
              $('#subscription-step-3-error').removeClass('d-none');
            }, 5000);
          }
        },
        rejected() {
          setTimeout(() => {
            $('#subscription-step-2-success').addClass('d-none');
            $('#subscription-step-3').addClass('d-none');
            $('#subscription-step-4').addClass('d-none');
            $('#subscription-step-3-error').removeClass('d-none');
          }, 5000);
          this.uninstall();
        },
      }
    );
  }
});
